import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { NgbModalModule, NgbCollapseModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
// import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
// import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { InputMaskModule } from '@ngneat/input-mask';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromInputs from '../shared/store/inputs';
import * as fromShippingPrices from './store/prices';

import { SHARED_COMPONENTS } from './components';
import { PAGE_COMPONENTS } from './pages';
import { MODAL_COMPONENTS } from './modals';
import { SHARED_DIRECTIVES } from './directives';
import { SHARED_PIPES } from './pipes';
import { ProfileSharedModule } from '@app/ecsomag/profile/profile-shared.module';
import { ParcelShopsStoreModule } from '../parcelshops/store/parcelshops-store.module';

@NgModule({
	imports: [StoreModule.forFeature(fromShippingPrices.featureKey, fromShippingPrices.reducer), EffectsModule.forFeature([fromShippingPrices.ShippingPricesEffects])],
})
export class ShippingPricesStoreModule {}

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		InputMaskModule,

		NgbModalModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbTooltipModule,
		// FontAwesomeModule,
		NgSelectModule,
		InlineSVGModule,

		TranslateModule,

		StoreModule.forFeature(fromInputs.featureKey, fromInputs.reducer, { initialState: fromInputs.initialState }),
		EffectsModule.forFeature([fromInputs.InputsEffects]),

		ParcelShopsStoreModule,
		ShippingPricesStoreModule,

		ProfileSharedModule,
	],
	declarations: [...SHARED_COMPONENTS, ...PAGE_COMPONENTS, ...MODAL_COMPONENTS, ...SHARED_DIRECTIVES, ...SHARED_PIPES],
	exports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		InputMaskModule,

		NgbModalModule,
		NgbDropdownModule,
		NgbCollapseModule,
		NgbTooltipModule,
		// FontAwesomeModule,
		NgSelectModule,
		InlineSVGModule,

		TranslateModule,

		...SHARED_COMPONENTS,
		...PAGE_COMPONENTS,
		...MODAL_COMPONENTS,
		...SHARED_DIRECTIVES,
		...SHARED_PIPES,
	],
})
export class SharedModule {
	// constructor(library: FaIconLibrary) {
	// 	library.addIcons(faTimes);
	// }
}
